import { defineComponent as h, computed as l, openBlock as a, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "4c22ef31-bc26-4b44-9b87-f131fe3511e9" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#4c22ef31-bc26-4b44-9b87-f131fe3511e9)" }, v = { key: 0 }, k = /* @__PURE__ */ p('<path fill="#eee" d="M0 0h512v416l-256 32L0 416Z"></path><path fill="#6da544" d="m396 280-67-8-34 3-24-2-54-2-93 13-8 12h299z"></path><path fill="#584528" d="m389 273-10-33-9-44-23-23-32-13-50 3-41-8-50 24-29 9-9 20-7 15 11 19 10 2 16-1 6-7 28-8-12 31-11 14-19 9 13 3 15 1 19-12 26-24 11 3 14 13-16 12 16 1 10-3 9-16-4-19 11 1 10 3 1 23-14 8 1 6h26l34-30 15 12 12 4-6 8 1 5h17l10-7zM84 340h178v32H84z"></path><path fill="#d80027" d="M0 416h512v96H0Z"></path><path fill="#584528" d="M288 340h140v32H288z"></path><path fill="#d80027" d="m71 182 69-50H55l69 50-26-81z"></path>', 6), g = { fill: "none" }, x = ["r"], y = /* @__PURE__ */ h({
  __name: "us-ca",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), s = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (w, z) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", u, [
        e.flagName ? (a(), i("title", v, d(e.flagName), 1)) : n("", !0),
        k
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  y as default
};
//# sourceMappingURL=us-ca-d58c4915.js.map
